import type { CollectedIntegrationConfig } from '@cli-types/next-adapter/runtime.js'
import { resolvePasswordEnvValue } from './resolve-password-env-value.js'
import { resolveTextEnvValue } from './resolve-text-env-value.js'

export async function collectRailwayBucketConfig(cwd: string): Promise<CollectedIntegrationConfig> {
  const overwriteEnvKeys = new Set<string>()
  const endpoint = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_ENDPOINT',
    message: 'Railway bucket S3 endpoint',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      try {
        if (!value?.trim()) throw new Error()
        new URL(value)
      } catch {
        return 'Enter a valid Railway bucket endpoint URL.'
      }
    }
  })
  const accessKeyId = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_ACCESS_KEY_ID',
    message: 'Railway bucket access key ID',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter the Railway bucket access key ID.'
    }
  })
  const secretAccessKey = await resolvePasswordEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_SECRET_ACCESS_KEY',
    message: 'Railway bucket secret access key',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter the Railway bucket secret access key.'
    }
  })
  const bucketName = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_NAME',
    message: 'Railway bucket name',
    defaultValue: 'media',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter the Railway bucket name.'
    }
  })
  const region = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_REGION',
    message: 'Railway bucket region',
    defaultValue: 'iad',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter the Railway bucket region.'
    }
  })
  const urlStyle = await resolveTextEnvValue({
    cwd,
    key: 'BETTERSTART_RAILWAY_BUCKET_URL_STYLE',
    message: 'Railway bucket URL style',
    defaultValue: 'path',
    cancelMessage: 'Railway Bucket configuration cancelled.',
    overwriteEnvKeys,
    validate(value) {
      if (!value?.trim()) return 'Enter the Railway bucket URL style.'
    }
  })

  return {
    sections: [
      {
        header: 'Storage (Railway Bucket)',
        vars: [
          { key: 'BETTERSTART_RAILWAY_BUCKET_ENDPOINT', value: endpoint.trim() },
          {
            key: 'BETTERSTART_RAILWAY_BUCKET_ACCESS_KEY_ID',
            value: accessKeyId.trim()
          },
          {
            key: 'BETTERSTART_RAILWAY_BUCKET_SECRET_ACCESS_KEY',
            value: secretAccessKey.trim()
          },
          { key: 'BETTERSTART_RAILWAY_BUCKET_NAME', value: bucketName.trim() },
          { key: 'BETTERSTART_RAILWAY_BUCKET_REGION', value: region.trim() },
          { key: 'BETTERSTART_RAILWAY_BUCKET_URL_STYLE', value: urlStyle.trim() }
        ]
      }
    ],
    overwriteKeys: overwriteEnvKeys
  }
}
